import { Location } from "../../../types/location/location";
import { LocationState } from "../../type/location-state";

interface Action {
  type: string;
  payload: {
    selectedLocation: Location;
  };
}

export const setSelectedLocationDispatch = (
  state: LocationState,
  action: Action
) => {
  const { selectedLocation } = action.payload;
  state.selectedLocation = selectedLocation;
};
